import { useCallback, useEffect, useMemo, useState } from "react";
import { paginate } from "../../utils";

const MAX_PAGE_SIZE = 10;
const INITIAL_PAGE = 1;

const usePaginate = (params) => {
  const [{ list, pageSize, page: currentPage, infinite }, setParams] = useState(
    {
      list: [],
      pageSize: MAX_PAGE_SIZE,
      page: INITIAL_PAGE,
      infinite: false,
      ...params,
    }
  );

  const { list: listaInicial } = params;

  const page = useMemo(() => paginate(list, pageSize, currentPage, infinite), [
    currentPage,
    infinite,
    list,
    pageSize,
  ]);

  const setList = useCallback((newList) => {
    setParams((current) => ({ ...current, list: newList }));
  }, []);

  const goTo = useCallback(
    (pageIndex = INITIAL_PAGE) => {
      setParams((current) => {
        const { pages } = page;

        const newPage = Math.max(Math.min(pageIndex, pages), INITIAL_PAGE);
        return {
          ...current,
          page: newPage,
        };
      });
    },
    [page]
  );

  const takeNext = useCallback(() => {
    const { page: currentPageIdx } = page;
    goTo(currentPageIdx + 1);
  }, [goTo, page]);

  const takePrevious = useCallback(() => {
    const { page: currentPageIdx } = page;
    goTo(currentPageIdx - 1);
  }, [goTo, page]);

  const takeFirst = useCallback(() => {
    goTo(INITIAL_PAGE);
  }, [goTo]);

  const takeLast = useCallback(() => {
    const { pages } = page;

    goTo(pages);
  }, [goTo, page]);

  useEffect(() => {
    setList(Array.isArray(listaInicial) ? listaInicial : []);
  }, [listaInicial, setList]);

  return {
    ...page,
    pageSize,
    currentPage,
    setList,
    goTo,
    takeNext,
    takePrevious,
    takeFirst,
    takeLast,
  };
};

export default usePaginate;
